var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdinals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0537,
    cy: 12.467,
    r: 7.9211,
    fill: "#0B8273",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2428 10.1214C20.2428 15.7113 15.7113 20.2428 10.1214 20.2428C4.53151 20.2428 0 15.7113 0 10.1214C0 4.53151 4.53151 0 10.1214 0C15.7113 0 20.2428 4.53151 20.2428 10.1214ZM6.54994 10.1214C6.54994 12.0939 8.14894 13.6929 10.1214 13.6929C12.0939 13.6929 13.6929 12.0939 13.6929 10.1214C13.6929 8.14894 12.0939 6.54994 10.1214 6.54994C8.14894 6.54994 6.54994 8.14894 6.54994 10.1214Z",
    fill: "#0B8273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdinals);
export default __webpack_public_path__ + "static/media/ordinals.653017567451c8a60027c3bee20ba755.svg";
export { ForwardRef as ReactComponent };